module.exports = __webpack_public_path__ + "62d6dc51.svg";